<template>
    <el-dialog :title="titleDialog" :visible="showDialog" @close="close" @open="create" class="dialog-import">
        <p class="mb-1">Subir un archivo Excel con una columna de los <strong>Códigos internos</strong> de sus productos y otra columna de la <strong>Cantidad a aumentar</strong>.</p>
        <el-tooltip class="item"
                        
                        effect="dark" placement="top-start">
                    <i class="fa fa-info-circle"></i>
                    <div slot="content">
                        <span v-html="tooltipContent"></span>
                    </div>
        </el-tooltip>
        <form autocomplete="off" @submit.prevent="submit">
            <div class="form-body">
                <div class="row">
                    <div class="col-12 form-group" :class="{'has-danger': errors.warehouse_id}">
                        <label for="warehouse">Almacén</label>
                        <el-select v-model="form.warehouse_id">
                            <el-option v-for="w in warehouses" :key="w.id" :label="w.description" :value="w.id"></el-option>
                        </el-select>
                        <small class="form-control-feedback" v-if="errors.warehouse_id" v-text="errors.warehouse_id[0]"></small>
                    </div>
                    <div class="col-12 form-group" :class="{'has-danger': errors.inventory_transaction_id}">
                        <label>Motivo traslado</label>
                        <el-select v-model="form.inventory_transaction_id" filterable>
                            <el-option v-for="option in inventory_transactions" :key="option.id" :label="option.name" :value="option.id"></el-option>
                        </el-select>
                        <small class="form-control-feedback" v-if="errors.inventory_transaction_id" v-text="errors.inventory_transaction_id[0]"></small>
                    </div>
                    <div class="col-12 form-group" :class="{'has-danger': errors.file}">
                        <el-upload
                                ref="upload"
                                :headers="headers"
                                action="/inventory/add_stock_from_excel"
                                :show-file-list="true"
                                :auto-upload="false"
                                :multiple="false"
                                :on-error="errorUpload"
                                :before-upload="onBeforeUpload"
                                :limit="1"
                                :data="form"
                                :on-success="successUpload">
                            <el-button slot="trigger" type="primary">Seleccione un archivo (xlsx)</el-button>
                        </el-upload>
                        <small class="form-control-feedback" v-if="errors.file" v-text="errors.file[0]"></small>
                    </div>
                    <div class="col-12 mt-4 mb-2">
                        <a class="text-dark mr-auto" href="/formats/import_product_inventory.xlsx" target="_new">
                            <span class="mr-2">Descargar formato de ejemplo para importar</span>
                            <i class="fa fa-download"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="form-actions text-right mt-5">
                <el-button @click.prevent="close()">Cancelar</el-button>
                <el-button type="primary" native-type="submit" :loading="loading_submit">Procesar</el-button>
            </div>
        </form>
    </el-dialog>
</template>

<script>

    export default {
        props: ['showDialog'],
        data() {
            return {
                loading_submit: false,
                headers: headers_token,
                titleDialog: null,
                tooltipContent: 'En caso del codigo no exista en el almacen seleccionado y en nigun otro almacen, no se tomara en cuenta.<br>En caso de que el codigo no exista en el seleccionado pero si existe en los otros almacenes, se creara el producto en el almacen seleccionado con el stock indicado.',
                errors: {},
                form: {},
                warehouses: [],
                inventory_transactions: []
            }
        },
        async created() {
            this.initForm();
            await this.onFetchTables();
        },
        methods: {
            onBeforeUpload(file) {},
            async onFetchTables() {
                this.loading_submit = true;
                await this.$http.get('/inventory/tables/transaction/input').then(response => {
                    this.warehouses = response.data.warehouses;
                    this.inventory_transactions = response.data.inventory_transactions;
                }).finally(() => this.loading_submit = false);
            },
            initForm() {
                this.errors = {}
                this.form = {
                    warehouse_id: null,
                    inventory_transaction_id: null
                }
            },
            create() {
                this.titleDialog = 'Importar Ingreso de Stock'
            },
            async submit() {
                if (!this.form.warehouse_id) {
                    this.$message.warning('Seleccione un almacén para poder continuar')
                    return
                }
                if (!this.form.inventory_transaction_id) {
                    this.$message.warning('Seleccione un motivo de traslado para poder continuar')
                    return
                }
                this.loading_submit = true
                await this.$refs.upload.submit()
                this.loading_submit = false
            },
            close() {
                this.$emit('update:showDialog', false)
                this.initForm()
            },
            successUpload(response, file, fileList) {
                if (response.success) {
                    const ignored = response.data.ignored != null ? response.data.ignored : 0
                    const msg = ignored > 0
                        ? `${response.message} (${ignored} producto(s) ignorado(s) por no cumplir criterios)`
                        : response.message
                    this.$message.success(msg)
                    this.$eventHub.$emit('reloadData')
                    this.$eventHub.$emit('reloadTables')
                    this.close()
                } else {
                    if (response.data && response.data.message_error) {
                        this.$message({
                            message: response.message,
                            type: 'error',
                            duration: 0,
                            showClose: true,
                            dangerouslyUseHTMLString: true,
                        })
                    } else {
                        this.$message({message: response.message, type: 'error'})
                    }
                }
                this.$refs.upload.clearFiles()
            },
            errorUpload(error) {
                console.log(error)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// modules/Inventory/Resources/assets/js/inventory/add_stock_import.vue